<div class="container">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content>
    {{data.message}}
  </mat-dialog-content>
  <mat-dialog-actions class="actionButtonsContainer">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button mat-dialog-close cdkFocusInitial color="primary" (click)="deleteActionButton()">Deletar</button>
  </mat-dialog-actions>
</div>